import { VariantProps } from "class-variance-authority";

import { useFormContext } from "..";
import { Button, buttonVariants } from "../../ui/button";

export interface SubmitButtonProps
  extends Omit<
    React.ComponentProps<"button"> &
      VariantProps<typeof buttonVariants> & {
        asChild?: boolean;
      },
    "type"
  > {
  children: React.ReactNode;
}

export const SubmitButton = ({ children, ...props }: SubmitButtonProps) => {
  const form = useFormContext();

  return (
    <form.Subscribe selector={state => state.isSubmitting}>
      {isSubmitting => (
        <Button type="submit" disabled={isSubmitting} {...props}>
          {children}
        </Button>
      )}
    </form.Subscribe>
  );
};
